import React from 'react'
import { Segment } from 'semantic-ui-react'
import { compose, withApollo, graphql } from 'react-apollo'
import {uploadFile} from '../utils/fileUploader'
import CropImage from './CropImage'
import {EmailMessage} from '../queries/EmailMessage'
import { CreateDocument } from '../mutations/CreateDocument'
import { DestroyDocument } from '../mutations/DestroyDocument'
import { UpdateDocument } from '../mutations/UpdateDocument'
import mapConnection from '../utils/connectionMapper'

class EmailCrop extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }
  handleDocumentFileSelected = (files) => {
    this.setState({loading: true})
    const task = this.props.task
    this.props.CreateDocument({
      variables: {
        input: {
          document: {
            emailMessageId: task.emailMessage.id,
            status: 'accepted'
          },
          claimsPassengerTicket: {
            passengerTicketId: task.claim.passengerTicketId,
            claimId: task.claim.id
          }
        }
      }
    }).then(({ data }) => {
        const documentId = data.createDocument.document.id
        const xhr = new XMLHttpRequest();
        xhr.onload = () => {
          this.props.EmailMessage.refetch()
        }
        xhr.onloadend = () => {
          this.setState({loading: false})
        }
        uploadFile(xhr, files[0],'/documents/'+ documentId + '/uploads')
      }).catch((error) => {
        this.setState({loading: false})
        console.error(error)
      });
  }
  handleCropComplete = (image, originalDocument)  => {
    this.setState({loading: true})
    const task = this.props.task
    this.props.CreateDocument({
        variables: {
          input: {
            document: {
              status: 'accepted',
              emailMessageId: task.emailMessage.id,
              documentId: originalDocument.id
            },
            claimsPassengerTicket: {
              passengerTicketId: originalDocument.claimsPassengerTicket.passengerTicket.id,
              claimId: task.claim.id
            }
          }
        }
      }).then(({data}) => {
          const xhr = new XMLHttpRequest();
          const id = data.createDocument.document.id

          xhr.onload = () => this.props.EmailMessage.refetch()
          xhr.onloadend = () => {
            this.setState({loading: false})
          }
          uploadFile(xhr, image, '/documents/'+ id +'/uploads')
      }).catch((error)=>{
        this.setState({loading: false})
        console.error(error)
      })
  }

  handleCroppedDocumentRotated = (image, croppedDocument) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = () => this.props.EmailMessage.refetch()

    uploadFile(xhr, image, 'documents/'+ croppedDocument.id +'/uploads')
  }

  handleDocumentTypeChanged = (type, document) => {
    this.setState({loading: true})
    this.props.UpdateDocument({
      variables: {
        input: {
          document: {
            id: document.id,
            type: String(type.value)
          }
        }
      }
    }).then(() => {
      this.setState({loading: false})
    }).catch((error) => {
      this.setState({loading: false})
      console.error(error)
    })
  }

  handleDocumentRemoved = (document) => {
    this.setState({loading: true})
    this.props.DestroyDocument({
        variables: {
          input: {
            id: document.id
          }
        }
      }).then(() => {
        this.setState({loading: false})
        this.props.EmailMessage.refetch()
      }).catch((error) => {
        this.setState({loading: false})
        console.error(error)
      })
  }

  handleDocumentAssignedPassengerChanged = (claimPassengerTicket, document) => {
    this.setState({ loading: true })
    this.props.UpdateDocument({
      variables: {
        input: {
          document: {
            id: document.id,
            status: "accepted"
          },
          claimsPassengerTicket: {
            passengerTicketId: claimPassengerTicket.passengerTicket.id,
            claimId: this.props.task.claim.id
          }
        }
      }
    }).then(() => {
      this.setState({ loading: false })
      this.props.EmailMessage.refetch()      
    }).catch((error) => {
      this.setState({ loading: false })
      console.log(error)
    })
  }

  render(){
    const email = this.props.EmailMessage.emailMessage || {}
    const originalDocuments = mapConnection(email.documentsConnection) || []
    const loading = this.props.EmailMessage.loading || this.state.loading
    const claim = email.claim || {}
    const CPTs = originalDocuments.filter(document => document.claimsPassengerTicket).map((document) => {
      const passengerId = document.claimsPassengerTicket.passengerTicketId
      return ({
        passengerId: passengerId,
        passengerTicket: document.claimsPassengerTicket.passengerTicket,
        document: document
      })
    }).reduce((acc, val) => {
      if(acc[val.passengerId]){
        acc[val.passengerId].documents.push(val.document)
        return acc
      }
      else {
        acc[val.passengerId] = {
          passengerTicket: val.passengerTicket,
          documents: [val.document]
        }
        return acc
      }
    }, {})
    
    const passengers = Object.keys(CPTs).map(key => CPTs[key])

    return (
      <Segment basic loading={loading}>
        <CropImage
          onFilesSelected = { this.handleDocumentFileSelected.bind(this) }
          onCropComplete = {this.handleCropComplete.bind(this)}
          onDocumentRotated = {this.handleCroppedDocumentRotated.bind(this)}
          onDocumentTypeChanged = {this.handleDocumentTypeChanged.bind(this)}
          onDocumentRemoved = {this.handleDocumentRemoved.bind(this)}
          onDocumentAssignedPassengerChanged={this.handleDocumentAssignedPassengerChanged.bind(this)}
          claim={claim}
          passengers={passengers}
        />
      </Segment>
    )
  }
}

const EmailCropWithData = compose(
  withApollo,
  graphql(CreateDocument, {name: "CreateDocument"}),
  graphql(UpdateDocument, {name: 'UpdateDocument'}),
  graphql(DestroyDocument, {name: 'DestroyDocument'}),
  graphql(EmailMessage, {
    name: "EmailMessage",
    options: (props) => {
      const emailMessage = props.task.emailMessage || {}
      return {
        variables: {
          id: emailMessage.id
        }
      }
    }
  })
)(EmailCrop)

export default EmailCropWithData



// WEBPACK FOOTER //
// ./src/component/EmailCrop.js